export const SITE_NAME = 'Paszport Dolnego Śląska'

/** Kanoniczny adres witryny (Open Graph, JSON-LD). Ustaw `VITE_PUBLIC_SITE_URL` w produkcji. */
export function getPublicSiteOrigin(): string {
  const fromEnv = import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined
  if (fromEnv?.trim() && /^https?:\/\//i.test(fromEnv.trim())) {
    return fromEnv.trim().replace(/\/$/, '')
  }
  if (typeof window !== 'undefined') {
    return window.location.origin
  }
  return ''
}

export function absoluteUrl(pathname: string): string {
  const origin = getPublicSiteOrigin()
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`
  if (!origin) return path
  return `${origin}${path}`
}

/** Pełny URL zasobu statycznego (OG / JSON-LD) z ścieżki względnej lub Vite. */
export function absoluteAssetUrl(assetPath: string): string {
  const trimmed = assetPath.trim()
  if (!trimmed) return ''
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`
  return absoluteUrl(path)
}
